import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_DeleteBackground = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/delete-background',
			name: 'Delete Background — Remove BG Online AI | Lift',
			description:
				'Delete photo background instantly with AI. No watermark. Delete background from image, convert JPG to PNG & create transparent backgrounds in seconds. Try now!',
			url: 'https://liftapp.ai/delete-background',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/delete-background#product' },
				{ '@id': 'https://liftapp.ai/delete-background#howto' },
				{ '@id': 'https://liftapp.ai/delete-background#benefits' },
				{ '@id': 'https://liftapp.ai/delete-background#faq' },
				{ '@id': 'https://liftapp.ai/delete-background#why-lift' },
				{ '@id': 'https://liftapp.ai/delete-background#explore-tools' },
				{ '@id': 'https://liftapp.ai/delete-background#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/delete-background#product',
			name: 'AI Background Deleter Online',
			description:
				'Delete backgrounds in seconds and download as transparent PNG. Online AI background deleter, no watermarks, batch up to 20 images. Try Lift Background Deleter now.',
			url: 'https://liftapp.ai/delete-background',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/delete-background#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Let the AI do the work',
					text: 'Watch as Lift deletes the background automatically',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/delete-background#benefits',
			name: 'Who can benefit from Background Deleter?',
			description:
				"Lift's AI Background Deleter is useful for professionals, creators, and businesses who want clean, transparent PNG images for e-commerce, social media, marketing, or personal use.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'E-commerce Sellers — Delete backgrounds from product photos to create clean, professional catalog images that drive sales. Process up to 20 images at once to build your Amazon, Shopify, or Etsy store faster',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Content Creators — Delete photo backgrounds to make stunning Instagram posts, YouTube thumbnails, and TikTok content. Cut out yourself or objects for collages, memes, and eye-catching designs without expensive software',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Designers & Freelancers — Delete image backgrounds instantly to speed up your workflow and deliver projects faster. Reduce manual retouching time and take on more clients while maintaining professional quality',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Small Business Owners — Delete background from logos, marketing materials, and promotional graphics in seconds. Create professional ads, flyers, and social media posts without hiring a designer',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Students & educators — Delete white backgrounds from images for school presentations, posters, and creative projects. Create professional-looking assignments and digital portfolios with transparent PNGs',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Delete background from logo',
				description:
					'Example of how Lift Background Deleter removes backgrounds and creates transparent PNG images for various use cases.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/delete-background#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift Background Deleter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift Background Deleter is a premium online tool that instantly deletes image backgrounds with pixel-perfect precision — ideal for product photos, profile pictures, or graphic design.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift Background Deleter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Simply upload your photo to Lift's background delete tool. Our AI automatically detects the subject and deletes the background in seconds — no photo editing experience needed. Download up to 20 cutout pictures with transparent PNG backgrounds.",
					},
				},
				{
					'@type': 'Question',
					name: 'Will it keep hair, edges, and fine details?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift Background Deleter uses advanced edge detection to preserve delicate elements like hair, fur, shadows, and soft textures — so you get clean, natural-looking cutouts without manual touch-ups.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/delete-background#why-lift',
			name: "Why Lift's AI Background Deleter stands out",
			description:
				"Lift's Background Deleter combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Delete background png',
				description:
					"Comparison of Lift's AI Background Deleter benefits — professional quality, AI accuracy, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/delete-background#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/delete-background#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Background Deleter',
					item: 'https://liftapp.ai/delete-background',
				},
			],
		},
	],
};
